import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, ERROR } from 'utils/constants';
import { fetchGroupsFailure, fetchGroupsSuccess } from '../actions';
import GroupActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* getGroups() {
  const url = `${API_BASE_URL}/application-groups`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    const returnedData = response.raw?.map((singleGroup) => ({
      value: singleGroup.id,
      label: singleGroup.name,
    }));

    yield put(fetchGroupsSuccess(returnedData));
  } else {
    yield put(
      fetchGroupsFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    Notify(response.message, {
      position: TOP_RIGHT,
      status: ERROR,
    });
  }
}

export function* onGetGroups() {
  yield takeLatest(GroupActionTypes.START_FETCH_GROUPS, getGroups);
}
